/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Image_RequiredInputs */

const en_landing_studio_image_required = /** @type {(inputs: Landing_Studio_Image_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload an image to edit first.`)
};

const zh_landing_studio_image_required = /** @type {(inputs: Landing_Studio_Image_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先上传要编辑的图片。`)
};

/**
* | output |
* | --- |
* | "Upload an image to edit first." |
*
* @param {Landing_Studio_Image_RequiredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_image_required = /** @type {((inputs?: Landing_Studio_Image_RequiredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Image_RequiredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_image_required(inputs)
	return zh_landing_studio_image_required(inputs)
});
export { landing_studio_image_required as "landing.studio.image_required" }